export default  {
    bindings: {
      extras: '<',
    },
    controller: 'extrasListController',
    template: require('../views/extras.list.html')
  };
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/extras.list.component.js